import type { Locale } from 'date-fns';
import { de, enGB } from 'date-fns/locale';

import type { Language } from './language';

export function dateFnsLocaleFor(language: Language): Locale {
	return language === 'de' ? de : enGB;
}

export function numberLocaleFor(language: Language): 'de-DE' | 'en-GB' {
	return language === 'de' ? 'de-DE' : 'en-GB';
}

/** English keeps the patterns the tables already use; German reads day-first. */
export function datePatternsFor(language: Language) {
	return language === 'de'
		? { dateTime: 'dd.MM.yyyy HH:mm:ss', date: 'dd.MM.yyyy', dateTimeShort: 'dd.MM.yyyy, HH:mm' }
		: { dateTime: 'yyyy-MM-dd HH:mm:ss', date: 'yyyy-MM-dd', dateTimeShort: 'dd MMM yyyy, HH:mm' };
}
